import { LicenseState } from "./types";

export function getDefaultState(): LicenseState {
	return {
		licenseDetails: {
			licenseKey: "",
			expirationDate: new Date(),
			isValid: false,
			maxCameras: 0,
			maxGuards: 0,
			maxOperators: 0,
			customer: {
				id: 0,
				email: "",
				name: ""
			}
		},
		userLimitDefinitions: {
			guardPermissions: [],
			operatorPermissions: []
		},
		isLoaded: false
	}
}